import { toast } from 'react-toastify';
import CustomToast from '../Component/CustomToast/CustomToast';


export const copyFormLink = (id) => {
  const formLink = `${window.location.origin}/user/fill-form/${id}`;
  navigator.clipboard.writeText(formLink)
    .then(() => {
      toast(<CustomToast message="لینک با موفقیت کپی شد" state="success" />);
    })
    .catch(() => {
      toast(<CustomToast message="کپی لینک ناموفق بود" state="not" />);
    });
};

